import React, { useEffect, useState } from 'react';
import VideoModal from '../../components/VideoModal';
import { ssoData } from '../sso';

const SsoTemp = () => {

    const [open, setOpen] = useState(false);
    const [demoData, setDemoData] = useState();
    const handleOpen = (videoData) => {
        setDemoData(videoData)
        setOpen(true);
    };
    const handleClose = () => setOpen(false);

    const [currentIndex, setCurrentIndex] = useState(0);
    const data = ['lorem','ipsum'];

    // const leftData = ssoData.slice(0,ssoData?.length/2);
    // const rightData = ssoData.slice(ssoData?.length/2,ssoData.length);

    useEffect(() => {
        const nextSlide = () => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
        };
    
        
        const intervalId = setInterval(nextSlide, 3000);
    
        return () => clearInterval(intervalId);
      }, [currentIndex, data.length]);

      const playPause = (event) =>{
        
        event.target.pauseVideo();
      }


    return (
        <>
            <div className="container-fluid">
                <div className='mx-2 mt-2'>
                    <div className='backButton d-flex align-items-center' onClick={()=>window.history.back()}>
                        <span class="material-symbols-rounded text-dark">
                            keyboard_arrow_left
                        </span>
                        <p className='mb-0'>Back</p>
                    </div>
                </div>
                <h5 className='text-center mb-4 mt-sm-0 mt-3 fw-bold'>Single Sign On</h5>
                <div className="row g-4 px-5 py-3">
                    {ssoData?.map((item, index) => (
                        <div key={index} className="col-sm-12 col-md-6 col-lg-4">
                            <div className="custom-shadow d-flex rounded-3 px-3 py-3 align-items-center" onClick={()=> handleOpen(item)} >
                                <div className="align-items-center text-14">
                                    <div className="d-flex justify-content-center bg-primary align-items-center me-3 rounded-circle" style={{height: "40px", width: "40px"}} >
                                        {item.icon}
                                    </div>
                                </div>
                                <div>
                                    <span style={{fontWeight:500, fontSize:'17px'}}>
                                        {item.text}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <VideoModal
                open={open}
                handleOpen={handleOpen}
                handleClose={handleClose}
                videoData={demoData}
            />
        </>
    )
}

export default SsoTemp